const BaseModel = require('../BaseModel');

class BaseRewardProvider extends BaseModel {
  static basePath = 'api/v1/rewards/providers';
  static dataType = 'reward-provider';
}

BaseModel.models[BaseRewardProvider.dataType] = BaseRewardProvider;
module.exports = BaseRewardProvider;
